import { render, staticRenderFns } from "./ItemEditor.vue?vue&type=template&id=4778f37d&scoped=true&"
import script from "./ItemEditor.vue?vue&type=script&lang=js&"
export * from "./ItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./ItemEditor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ItemEditor.vue?vue&type=style&index=1&id=4778f37d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4778f37d",
  null
  
)

export default component.exports